import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Release Feedback", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "1 team", -1)
const _hoisted_5 = ["onClick"]

import TandemModal from "@/components/TandemModal.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackReleaseModal',
  props: {
    teamCount: {}
  },
  emits: ["release"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TandemModal, { class: "form-body" }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    directions: _withCtx(() => [
      (_ctx.teamCount > 1)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
            _createTextVNode(" Are you want to release feedback to "),
            _createElementVNode("b", null, _toDisplayString(_ctx.teamCount) + " teams", 1),
            _createTextVNode("? ")
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_3, [
            _createTextVNode(" Are you sure you want to release feedback to "),
            _hoisted_4,
            _createTextVNode("? ")
          ]))
    ]),
    buttons: _withCtx(({ close }) => [
      _createElementVNode("button", {
        type: "button",
        class: "btn",
        onClick: close
      }, " Cancel ", 8, _hoisted_5),
      _createElementVNode("button", {
        class: "btn btn-burg",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('release')))
      }, " Yes, Release Feedback ")
    ]),
    _: 1
  }))
}
}

})